const Forms = () => {
    const formFields = document.querySelectorAll('input:not([name="s"])');
    formFields.forEach(function (field) {
        field.addEventListener('focus', function () {
            loadReCaptcha();
        }, { once: false });
    });

    let recaptchaLoaded = false;

    const loadReCaptcha = () => {
        if (!recaptchaLoaded) {
            let script = document.createElement('script');
            const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');
            script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
            script.onload = function () {
                grecaptcha.ready(function () {
                    grecaptcha.execute(siteKey, { action: 'homepage' }).then(function (token) {
                        const inputElement = document.querySelector("input[name='g-recaptcha-response']");
                        if (inputElement) {
                            inputElement.value = token;
                        }
                    });
                });
            };
            document.head.appendChild(script);
            recaptchaLoaded = true;

            let rdsScript = document.createElement('script');
            rdsScript.src = 'https://d335luupugsy2.cloudfront.net/js/loader-scripts/c2a8427d-e4e1-4b74-9c8e-ca89b1345c66-loader.js';
            document.head.appendChild(rdsScript);
        }
    }
};

export default Forms;

window.reloadCaptcha = function reloadCaptcha(action, fieldName = 'g-recaptcha-response', fn = null) {
    grecaptcha.ready(function () {
        const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');

        grecaptcha
            .execute(siteKey, {
                action: action,
            })
            .then(function (token) {
                const inputElement = document.querySelector("input[name='" + fieldName + "']");
                if (inputElement) {
                    inputElement.value = token;
                }

                if (fn) {
                    fn();
                }
            });
    });
};
